import styled from 'styled-components';
import {Field} from 'redux-form';

import {ContentStyled} from '../../styles/components/content.style';
import {media} from '../../styles/components/media-queries';
import {Button2a} from '../../styles/components/button.style';

export const CheckoutWrapperStyled = ContentStyled.extend`
  padding: 0;
  display: flex;
  max-width: ${props => props.theme.container.wider.width};
`;

export const CheckoutPageContentStyled = styled.main`
  flex-grow: 2;
  color: ${props => props.theme.checkoutPage.color};
  background-color: ${p => p.isTemplateLight ? p.theme.checkoutPage.backgroundColor : p.theme.primaryBackground};
  margin-right: ${p => p.isTemplateLight ? p.theme.checkoutPage.margin : p.theme.margin};
  border-right: ${p => p.isTemplateLight ? p.theme.checkoutPage.borderRight : p.theme.margin};
  margin-bottom: auto;
  padding: ${props => props.theme.content.padding};
  ${media.small`
    margin-right: 0;
  `};
  a {
    text-decoration: underline;
    color: ${props => props.theme.checkoutPage.linkColor};
  }
`;

export const Label = styled.label`
  display: block;
  color: ${props => props.theme.checkoutPage.bigLabelColor};
  font-size: 2rem;
  font-weight: ${p => p.theme.checkoutPage.fontWeight};
  small {
    margin-left: 0.6rem;
    color: ${props => props.theme.checkoutPage.smallTextColor};
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1;
  }
`;

export const Title = styled.span`
  color: ${props => props.theme.checkoutPage.bigLabelColor};
  font-size: 2rem;
  font-weight: bold;
  ${media.small`
    display: block;
  `};
`;

export const OptInWrapper = styled.div`
  display: flex;
  ${media.medium`
    flex-direction: column;
  `};
`;

export const CheckboxWrapper = styled.label`
  display: flex;
  line-height: 1.4rem;
  align-items: center;
  font-size: 1.4rem;
`;

export const CheckoutBoxesWrapper = styled.div`
  display: flex;
  padding: 0.4rem 0 0 1rem;
  ${media.medium`
    padding: 1.4rem 0 1rem;
  `};
`;

export const NoFee = styled.img`
  width: 32%;
  max-width: 16rem;
  min-height: 32%;
  position: absolute;
  right: 0;
  top: 0;
  transform: rotate(-20deg);
`;

export const PaymentLogo = styled.img`
  width: 12.5rem;
  height: 1.8rem;
`;

export const OptionsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
`;

export const WebsiteBy = styled.a`
  display: flex;
  text-decoration: none;
`;

export const ProviderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ProviderBy = styled.span`
  font-size: 1rem;
  padding-right: 0.6rem;
  color: ${p => p.theme.checkoutPage.smallTextColor};
`;

export const OptInInfo = styled.div`
  font-size: 1.2rem;
  padding-top: 1rem;
  line-height: 1.4rem;
  color: ${props => props.theme.checkoutPage.smallTextColor};
`;

export const DeliveryAddressLabel = styled.label`
  color: ${props => props.theme.checkoutPage.deliveryAddressLabelColor};
  margin-bottom: 0;
`;

export const OrderTypeLabel = styled.label`
  color: ${props => props.theme.checkoutPage.bigLabelColor};
  font-size: 2rem;
  font-weight: bold;
`;

export const TableNumberLabel = styled(OrderTypeLabel)`
  color: ${props => props.theme.checkoutPage.bigLabelColor};
  margin-left: 0.5rem;
`;

export const ChooseServiceTypeOption = styled.div`
  display: inline-block;
`;

export const ServiceTypeOptionDiv = styled.div`
  display: inline-block;
  margin-left: 1.4rem;
  ${media.small`
    margin-left: 0;
    margin-right: 1.4rem;
  `};
`;

export const DeliveryOption = styled.input`
  margin-right: 0.6rem;
`;

export const TextInput = styled.input`
  display: block;
  margin: 0;
  padding: 0.4rem 0.8rem;
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background: ${p => p.error ? p.theme.checkoutPage.inputErrorBackgroundColor : p.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 3.6rem;
  box-sizing: border-box;
  width: 100%;
`;

export const TextInputError = styled.span`
  display: block;
  color: ${props => props.theme.checkoutPage.requiredMessageColor};
  font-size: 1.6rem;
  font-weight: normal;
`;

export const FieldRow = styled.div`
  display: flex;
  margin-bottom: ${p => p.hasLink ? '1rem' : '2rem'};
  ${media.medium`
    display: block;
  `};
`;

export const FieldDiv = styled.div`
  width: 100%;
  margin-right: ${props => props.nomargin ? '0' : '1rem'};
  ${media.medium`
    margin-top: ${props => props.nomargin ? '2rem' : '0'};
  `};
`;

export const CommentTextArea = styled(Field)`
  display: block;
  margin: 0;
  padding: 0.4rem 0.8rem;
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background: ${props => props.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 3.6rem;
  box-sizing: border-box;
  width: 100%;
`;

export const SubscribeWrapper = styled.div`
  padding-bottom: 1rem;
`;

export const Checkbox = styled(Field)`
  margin: 0 0.6rem 0 1rem;
  padding: 0.4rem 0.8rem;
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 3.6rem;
  box-sizing: border-box;
  ${media.medium`
    margin-left: 0;
  `};
`;

export const CheckboxText = styled.div`
  font-size: 1.6rem;
  ${media.medium`
    margin-right: 1rem;
  `};
`;

export const Error = styled.div`
  background-color: ${props => props.theme.checkoutPage.formErrorBackground};
  color: ${props => props.theme.checkoutPage.formErrorColor};
  padding: 1rem;
  margin-bottom: 1.4rem;
`;

export const DeliveryFeeMessage = styled.div`
  background-color: ${props => props.theme.checkoutPage.deliveryFeeBackgroundColor};
  color: ${props => props.theme.checkoutPage.formErrorColor};
  padding: 1rem;
  margin-bottom: 1.4rem;
`;

export const FormError = Error.extend`
  margin-top: ${p => p.theme.margin};
`;

export const PaymentsContainer = styled.div`
  border: 1px solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background-color: ${props => props.theme.checkoutPage.payment.backgroundColor};
`;

export const PaymentOptionsRow = styled.div`
  padding: 1.2rem 2.4rem;
  border-bottom: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.medium`
    padding: 1.2rem;
    display: block;
  `};
  ${media.small`
    display: flex;
  `};
`;

export const ChoosePaymentOptionRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.2rem 2.4rem;
  border-bottom: 1px solid ${props => props.theme.checkoutPage.inputTextBorderColor};
`;

export const CompleteOrderWrapper = styled.div`
  display: flex;
  ${media.small`
    display: block;
  `};
`;

export const CompleteOrderBtn = Button2a.extend`
  margin-top: ${p => p.theme.margin};
  margin-bottom: ${p => p.theme.margin};
  width: 24rem;
  background-color: ${props => props.greyed ? props.theme.disabledButtonBackground : props.theme.secondaryColor};
  border-bottom: ${props => props.greyed ? props.theme.button.secondary.borderBottom : props.theme.button.primary.borderBottom};
  ${media.small`
    width: 100%;
  `};
`;

export const PaymentOptionsTitle = styled.h4`
  font-size: ${props => props.theme.checkoutPage.payment.title.fontSize};
  line-height: 2rem;
  margin: 1rem 0;
`;

export const OptionLabel = styled.label`
  color: ${props => props.isDisabled ? props.theme.disabledTextColor: props.theme.checkoutPage.textColor};
  small {
    color: ${props => props.theme.checkoutPage.smallTextColor};
    font-size: 1.2rem;
    font-weight: normal;
  }
`;

export const PaymentDisclaimerRow = styled.div`
  padding: 0 2.4rem 1.2rem;
  background: ${p => p.theme.checkoutPage.paymentsDisclamerBackground};
  margin: 0;
`;

export const PaymentDisclaimerLogosRow = styled.div`
  padding-top: 1.2rem;
  border-top: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.medium`
    display: block;
  `};
`;

export const Select = styled.select`
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background: ${props => props.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  width: 100%;
  height: 4.8rem;
`;

export const ButtonText = styled.span`
  line-height: 2.4rem;
`;

export const ErrorReport = styled.div`
  font-size: 1.2rem;
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${p => p.theme.margin};
  cursor: pointer;
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const NotDineIn = styled.div`
  color: ${p => p.theme.secondaryColor};
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  font-size: ${p => p.theme.checkoutPage.fontSize};
  ${media.small`
    align-items: center;
    padding-right: 1.2rem;
  `};
`;

export const NotDineInLink = styled.a`
  text-decoration: underline;
  padding-left: 0.6rem;
`;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/CheckoutPage.style.js